<section class="cx-section">
  <mat-card>
    <h1 class="update-address__title">{{ 'address.title' | cxTranslate }}</h1>
    <div class="update-address__section">
      <div class="update-address__section__content">
        <p class="update-address__section__content__text">{{ 'address.downloadFormText' | cxTranslate }}</p>
        <p class="update-address__section__content__text">{{ 'address.downloadFormNote' | cxTranslate }}</p>
        <div class="update-address__section__content__form">
          <img class="update-address__section__content__delivery-icon" src="public/icons/shipping.png" />
          <b
            >Update or add new delivery address form:
            <u
              ><a
              class="update-address__section__content__download-link"
              target="_blank"
              href="https://forms.office.com/e/aHf04rxNNb"
              >{{ 'address.downloadForm' | cxTranslate }}
            </a></u
            >
          </b>
        </div>
      </div>
    </div>
  </mat-card>

  @if ((shippingAddresses$ | async)?.length) {
    @if (!(addressesStateLoading$ | async)) {
      <div>
        <div class="address-panel col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-accordion multi>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ 'address.shippingAddresses' | cxTranslate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                @for (address of shippingAddresses$ | async; track address; let i = $index) {
                  <div class="col-md-6 cx-address-card">
                    <app-card
                      [border]="true"
                      [fitToContainer]="true"
                      [content]="getCardContent(address) | async"
                      (setDefaultCard)="setAddressAsDefault(address)"
                    ></app-card>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
        <div class="address-panel col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <mat-accordion multi>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ 'address.billingAddresses' | cxTranslate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                @for (address of billingAddresses$ | async; track address; let i = $index) {
                  <div class="col-md-6 cx-address-card">
                    <app-card
                      [border]="true"
                      [fitToContainer]="true"
                      [content]="getCardContent(address) | async"
                      (setDefaultCard)="setAddressAsDefault(address)"
                    ></app-card>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    } @else {
      <div class="col-md-12 cx-address-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  }
</section>

